(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-apiary"]) return;
  try {
    
  function initApiaryPlayers() {
    document.querySelectorAll('[data-apiary-player]').forEach((player) => {
      if (player.dataset.ready) return;
      const video = player.querySelector('video');
      const button = player.querySelector('button');
      if (!video || !button) return;
      player.dataset.ready = 'true';
      const mobile = window.matchMedia('(max-width: 760px)');
      let controlsRequested = false;
      video.controls = false;
      button.hidden = false;
      button.addEventListener('click', () => {
        controlsRequested = false;
        video.controls = !mobile.matches;
        video.play().catch(() => {
          video.controls = true;
          button.hidden = true;
        });
      });
      video.addEventListener('play', () => {
        button.hidden = true;
        video.tabIndex = 0;
        video.controls = !mobile.matches || controlsRequested;
      });
      const revealControls = () => {
        if (video.paused || video.controls) return;
        controlsRequested = true;
        video.controls = true;
      };
      video.addEventListener('click', (event) => {
        if (!video.controls && !video.paused) {
          event.preventDefault();
          revealControls();
        }
      });
      video.addEventListener('focus', revealControls);
      video.addEventListener('keydown', (event) => {
        if (!video.controls && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          revealControls();
        }
      });
      video.addEventListener('ended', () => {
        const restoreFocus = document.activeElement === video;
        video.controls = false;
        video.removeAttribute('tabindex');
        button.querySelector('span').textContent = button.dataset.replayLabel;
        button.hidden = false;
        video.load();
        if (restoreFocus) button.focus({ preventScroll: true });
      });
      video.addEventListener('error', () => {
        video.controls = true;
        button.hidden = true;
      });
    });
  }
  initApiaryPlayers();
  document.addEventListener('shopify:section:load', initApiaryPlayers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-footer"] && !Shopify.designMode) return;
  try {
    
const footer = document.querySelector('.site-footer');
if (footer && 'IntersectionObserver' in window) {
  new IntersectionObserver(([entry]) => {
    document.body.classList.toggle('gg-footer-in-view', entry.isIntersecting);
  }).observe(footer);
}

  } catch(e) { console.error(e); }
})();
})();
